import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import * as io from "socket.io-client";
import { BehaviorSubject, Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class SocketioService {

  public countplace$: BehaviorSubject<string> = new BehaviorSubject('');
  public countTree$: BehaviorSubject<string> = new BehaviorSubject('');
  public countDot$: BehaviorSubject<string> = new BehaviorSubject('');
  public countTreeProblem$: BehaviorSubject<string> = new BehaviorSubject('');
  public TreeProblemData$: BehaviorSubject<string> = new BehaviorSubject('');
  public countTreeProject$: BehaviorSubject<string> = new BehaviorSubject('');
  public TreeProjectData$: BehaviorSubject<string> = new BehaviorSubject('');
  public countAssessment$: BehaviorSubject<string> = new BehaviorSubject('');
  public assessmentData$: BehaviorSubject<string> = new BehaviorSubject('');

  socket: any;
  private isConnected = false;

  constructor() { 

    // Initialize socket connection with proper configuration for v2.x
    try {
      this.socket = io(environment.apiUrl, {
        transports: ['websocket', 'polling'],
        timeout: 5000,
        forceNew: true,
        autoConnect: false // Manual connection control
      });

      this.socket.on('connect', () => {
        console.log('Socket connected successfully');
        this.isConnected = true;
      });

      this.socket.on('connect_error', (error: any) => {
        console.error('Socket connection error:', error);
        this.isConnected = false;
        // Retry connection after 5 seconds
        setTimeout(() => {
          if (!this.isConnected) {
            console.log('Retrying socket connection...');
            this.socket.connect();
          }
        }, 5000);
      });

      this.socket.on('disconnect', (reason: any) => {
        console.log('Socket disconnected:', reason);
        this.isConnected = false;
      });

      // Try to connect
      this.socket.connect();
    } catch (error) {
      console.error('Socket initialization error:', error);
      this.isConnected = false;
    }
  }

  // Check if socket is connected
  public isSocketConnected(): boolean {
    return this.isConnected && this.socket && this.socket.connected;
  }

  // Manually reconnect socket
  public reconnectSocket(): void {
    if (this.socket) {
      this.socket.disconnect();
      this.socket.connect();
    }
  }

  // Place
  public sendCountPlace(place: any) {
    if (this.isSocketConnected()) {
      this.socket.emit('countplace', place);
    } else {
      console.warn('Socket not connected, cannot send countplace');
    }
  }

  public getCountPlace = () => {
    if (this.isSocketConnected()) {
      this.socket.on('countplace', (place) => {
        this.countplace$.next(place)
      })
    }
    return this.countplace$.asObservable();
  }


  // Tree
  public sendCountTree(countTree: any) {
    if (this.isSocketConnected()) {
      this.socket.emit('countTree', countTree);
    } else {
      console.warn('Socket not connected, cannot send countTree');
    }
  }

  public getCountTree = () => {
    if (this.isSocketConnected()) {
      this.socket.on('countTree', (countTree) => {
        this.countTree$.next(countTree)
      })
    }
    return this.countTree$.asObservable();
  }

  // Dot
  public sendCountDot(countDot: any) {
    if (this.isSocketConnected()) {
      this.socket.emit('countDot', countDot);
    } else {
      console.warn('Socket not connected, cannot send countDot');
    }
  }

  public getCountDot = () => {
    if (this.isSocketConnected()) {
      this.socket.on('countDot', (countDot) => {
        this.countDot$.next(countDot)
      })
    }
    return this.countDot$.asObservable();
  }


  //Tree Update Socket
  public sendCountTreeProblem(countTreeProblem: any) {
    this.socket.emit('countTreeProblem', countTreeProblem);
  }

  public getCountTreeProblem = () => {
    this.socket.on('countTreeProblem', (countTreeProblem) => {
      this.countTreeProblem$.next(countTreeProblem)
    })
    return this.countTreeProblem$.asObservable();
  }

  public sendTreeProblemData(TreeProblemData: any) {
    this.socket.emit('TreeProblemData', TreeProblemData);
  }

  public getTreeProblemData = () => {
    this.socket.on('TreeProblemData', (TreeProblemData) => {
      this.TreeProblemData$.next(TreeProblemData)
    })
    return this.TreeProblemData$.asObservable();
  }

// Tree Project
public getCountTreeProject = () => {
  this.socket.on('countTreeProject', (countTreeProject) => {
    this.countTreeProject$.next(countTreeProject)
  })
  return this.countTreeProject$.asObservable();
}

public sendCountTreeProject(countTreeProject: any) {
  this.socket.emit('countTreeProject', countTreeProject);
}

//Assessment
  public sendCountAssessment(countAssessment: any) {
    this.socket.emit('countAssessment', countAssessment);
  }

  public getCountAssessment = () => {
    this.socket.on('countAssessment', (countAssessment) => {
      this.countAssessment$.next(countAssessment)
    })
    return this.countAssessment$.asObservable();
  }

}
